import { useMemo } from 'react';
import { includes } from 'lodash';
import { useUserInfoContext } from '@/contexts/user-info-context';

/**
 * 检查当前用户在 active_space 是否有指定的功能权限
 * @param permission 需要的权限点
 * @returns boolean
 * 注： 当前权限挂在空间下，因为没有创建role的入口，所以权限没有挂在role上，后续如果挂在role上，这里的结构会改
 * 现在的结构是：
 * "role": 
 *  [
      {
          "role_id": "047fa00e-84bc-4828-af0e-16905e94330c",
          "role_name": "空间管理员"
      }
    ],
    "permission": [
      "space:manage"
    ]
  取permission的值，如果有"space:manage"，就表示有管理后台的权限
 */
export const usePermissionCheck = (permission: string) => {
  const { userInfo } = useUserInfoContext();
  const userPermissions = userInfo?.active_space?.permission ?? [];

  return useMemo(() => {
    return includes(userPermissions, permission);
  }, [userPermissions, permission]);
};
